<template>
    <DxTabPanel>
        <DxItem title="Consulta Stock Brigada" template="dashboar-query-stock-brigade-tab" />
        <template #dashboar-query-stock-brigade-tab>
            <b-card :class="[dark ? 'dark-mode-page' : '']">
                <b-row>
                    <b-col class="form-group col-6">
                        <label :class="[dark ? 'text-white' : '']">Seleccione:</label>
                        <Select2 class="select2 mb-3" v-model="form.selectedContrata" :options="contratas"
                            @change="onChangeContrata($event)" placeholder="Filtrar contratas" />
                    </b-col>
                    <b-col class="form-group col-6">
                        <label :class="[dark ? 'text-white' : '']">Brigadas:</label>
                        <Select2 class="select2 mb-3" v-model="form.selectedBrigades" :options="brigades"
                            :disabled="brigades.length === 0 || form.bStockStore"
                            :settings="{ placeholder: 'Filtrar brigade', multiple: true }" />
                    </b-col>
                    <b-col class="form-group col-6 mt-2">
                        <label :class="[dark ? 'text-white checkbox checkbox-success' : 'checkbox checkbox-success']">
                            <input type="checkbox" name="Checkboxes5" @click="onCheckClick"
                                v-model="form.bStockStore" />
                            <span></span>Stock Almacen</label>
                    </b-col>
                    <b-col>
                        <button class="btn btn-sm btn-primary btn-circle" @click="onQueryStockBrigade()"
                            :disabled="isLoading">
                            <span v-if="!isLoading">
                                <i class="fa fa-regular fa-file-excel"></i>
                                Consultar
                            </span>
                            <span v-else>Cargando...</span>
                        </button>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col v-if="dataReport.items.length">
                        <ReportStockDataGrid :items="dataReport.items" :isStockStorage="dataReport.isStockStore"
                            :key="nKey" />
                    </b-col>
                    <b-col v-else>
                        <div v-if="isLoading" class="d-flex justify-content-center aling-items-center">
                            <img src="assets/img/loader.gif" alt="Loading..." />
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </template>
    </DxTabPanel>
</template>

<script>
import axios from "axios";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import { mapGetters } from "vuex";
import ReportStockDataGrid from './utils/ReportStockDataGrid.vue';

export default {
    components: {
        DxTabPanel,
        DxItem,
        ReportStockDataGrid,
    },
    computed: {
        ...mapGetters({
            dark: "mode/getTheme",
        }),
    },
    mounted() {
        this.onGetContratas();
    },
    data() {
        return {
            isLoading: false,
            nKey: 0,
            contratas: [],
            brigades: [],
            form: {
                selectedContrata: -1,
                selectedBrigades: [],
                bStockStore: false,
            },
            dataReport: {
                items: [],
                isStockStore: false,
            }
        };
    },
    methods: {
        async onQueryStockBrigade() {
            this.isLoading = true;
            this.dataReport = {
                items: [],
                isStockStore: this.form.bStockStore,
            }
            try {
                if(this.form.selectedContrata === -1 || this.form.selectedContrata === '-1'){
                     this.$swal.fire(
                        "Aviso!",
                        "Debe Seleccionar la delegacion/aliado",
                        "warning"
                    );
                    this.isLoading = false;
                    return;
                }

                if(this.form.selectedContrata != -1 && !this.form.bStockStore && this.form.selectedBrigades.length === 0){
                     this.$swal.fire(
                        "Aviso!",
                        "Debe checkear si desea consultar el stock del almacen.",
                        "warning"
                    );
                    this.isLoading = false;
                    return;
                }

                const { data, status } = await axios.post("reportStockBrigada", { form: this.form });
                if (status === 200 && data.success) {
                    this.$swal.fire("Información!", data.message, "success");
                    this.dataReport = {
                        items: data.data,
                        isStockStore: this.form.bStockStore,
                    }
                    this.isLoading = false;
                    this.nKey++;
                } else {
                    console.log({ data, status });
                    this.$swal.fire(
                        "Información!",
                        "No se ha encontrado informacion",
                        "info"
                    );
                     this.dataReport = {
                        items: [],
                        isStockStore: this.form.bStockStore,
                    }
                    this.isLoading = false;
                    this.nKey++;
                    return;
                }
            } catch (error) {
                console.log({ error });
                this.$swal.fire(
                    "Error!",
                    "Ocurrió un error al generar el reporte. Inténtelo nuevamente.",
                    "error"
                );
                this.nKey++;
                this.isLoading = false;
            }
        },
        async onGetContratas() {
            try {
                this.contratas = [];
                this.contratas.push({
                    id: -1,
                    text: "Seleccione",
                });
                const { data, status } = await axios.get("/contratasDP");
                if (status === 200) {
                    const aContratas = data.map((contrata) => ({
                        id: contrata.id,
                        text: contrata.cliente,
                        db: contrata.nombre,
                        codempresa: contrata.codempresa,
                    }));
                    this.contratas = [...this.contratas, ...aContratas];
                }
            } catch (error) {
                console.log(error);
            }
        },
        async onChangeContrata(idContrata) {
            try {
                if (idContrata !== '-1') {
                    this.brigades = [];
                    const { codempresa } = this.contratas.find((contrata) => contrata.id == idContrata);
                    const { data, status } = await axios.get(`/listTecnicos?codempresa=${codempresa}`);
                    if (status === 200) {
                        this.brigades = data.data.map((briagde) => ({
                            id: briagde.id,
                            text: briagde.texto
                        }));
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        onCheckClick() {
            this.form.selectedBrigades = [];
        }
    },
};
</script>
